/**
 * ข้อความสาขาของคู่ค้าต่อท้ายเลขประจำตัวผู้เสียภาษี แบบเดียวกับของบริษัทเอง "0107557000080 (สำนักงานใหญ่)"
 *
 * `lab_companies.branch_code` บน UAT มีทั้ง "สำนักงานใหญ่", "00000" (รหัสสำนักงานใหญ่ของสรรพากร),
 * เลขสาขา 5 หลักอย่าง "00010" และว่าง (ส่วนใหญ่) — ว่างคือไม่รู้ จึงไม่แสดงอะไร (30 ก.ย. 2569)
 */
export const formatPartyBranch = (branchCode?: string | null): string => {
  const code = String(branchCode ?? '').trim()
  if (!code) return ''
  if (code === 'สำนักงานใหญ่' || /^0+$/.test(code)) return '(สำนักงานใหญ่)'
  if (/^\d+$/.test(code)) return `(สาขา ${code.padStart(5, '0')})`
  return code.startsWith('สาขา') ? `(${code})` : `(สาขา ${code})`
}

export const formatTaxIdWithBranch = (taxId?: string | null, branchCode?: string | null): string => {
  if (!taxId) return '-'
  const branch = formatPartyBranch(branchCode)
  return branch ? `${taxId} ${branch}` : taxId
}
